<template>
  <div class="d-flex flex-wrap mx-n1 px-4 filter-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FilterWrapper',
  
}
</script>
<style scoped>
::v-deep .flex-wrapper .v-label {
 font-weight: bold !important;
 color: red;
}
</style>